var _rect, _mask, _rect2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.958648,
    y: 1.39224,
    width: 28.2155,
    height: 28.2155,
    rx: 2.0819,
    stroke: "#366CD6",
    strokeWidth: 1.78448
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3623_3528",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.06641,
    y: 5.25,
    width: 20,
    height: 20,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.06641,
    y: 5.25,
    width: 20,
    height: 20,
    rx: 1,
    stroke: "#366CD6",
    strokeWidth: 3,
    mask: "url(#path-2-inside-1_3623_3528)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.8164,
    y1: 19,
    x2: 5.56641,
    y2: 19,
    stroke: "#366CD6",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareIcon);
export default __webpack_public_path__ + "static/media/compare-icon.909a91fd137604fc242475a086cc3678.svg";
export { ForwardRef as ReactComponent };